import { SETTLEMENT_IDS, SKILL_IDS } from "../content/core";
import { ITEMS } from "../content/items";
import { QUESTS } from "../content/quests";
import type { GameState, ObjectiveDefinition, SkillId } from "../game/types";

export function currentObjectiveValue(state: GameState, objective: ObjectiveDefinition, recorded: number): number {
  if (objective.type === "collect" && ITEMS[objective.target]) {
    return Math.max(recorded, state.inventory.filter((stack) => stack.itemId === objective.target).reduce((sum, stack) => sum + stack.quantity, 0));
  }
  if (objective.type === "skill") {
    if (SKILL_IDS.includes(objective.target as SkillId)) return state.skills[objective.target as SkillId].level;
    if (objective.target === "charter-skill" || objective.target === "mastery") return Math.max(...Object.values(state.skills).map((skill) => skill.level));
  }
  if (objective.type === "friendship") {
    if (state.npcs[objective.target]) return state.npcs[objective.target].friendship;
    if (objective.target === "all-settlements") return Math.min(...SETTLEMENT_IDS.filter((id) => id !== "lantern-acre").map((id) => state.reputation[id] ?? 0));
  }
  if (objective.type === "pet") {
    if (objective.target === "named-pets") return state.pets.length;
    if (objective.target === "affinity") return Math.max(0, ...state.pets.map((pet) => pet.affinity));
    if (objective.target === "level") return Math.max(0, ...state.pets.map((pet) => pet.level));
  }
  if (objective.type === "build") {
    if (objective.target === "cabin-tier-4") return state.buildings.find((building) => building.buildingId === "cabin")?.tier ?? 0;
    if (objective.target === "specialist-buildings") return new Set(state.buildings.map((building) => building.buildingId)).size;
    return Math.max(recorded, state.buildings.filter((building) => building.buildingId === objective.target).length);
  }
  if (objective.type === "earn" && objective.target === "civic-marks") return state.civicMarks;
  return recorded;
}

export function syncObjectiveProgress(state: GameState): GameState {
  for (const [questId, progress] of Object.entries(state.quests)) {
    if (progress.status !== "active") continue;
    const quest = QUESTS[questId];
    if (!quest) continue;
    quest.objectives.forEach((objective, index) => {
      progress.progress[index] = Math.min(objective.amount, currentObjectiveValue(state, objective, progress.progress[index]));
    });
  }
  return state;
}
